import jQuery from 'jquery';

// Legacy plugins and inline Blade scripts expect a global jQuery, so this
// module must be imported before anything that depends on it.
window.$ = window.jQuery = jQuery;
